import { adminEndpoints } from './admin';
import { authEndpoints, setupEndpoints } from './auth';
import { conversationsEndpoints } from './conversations';
import type { AnyEndpoint } from './endpoint';
import { eventsEndpoints } from './events';
import { filesEndpoints } from './files';
import { invitationsEndpoints } from './invitations';
import { linkPreviewsEndpoints } from './links';
import { messagesEndpoints } from './messages';
import { pushEndpoints } from './push';
import { releasesEndpoints } from './releases';
import { searchEndpoints } from './search';
import { serverInfoEndpoints } from './server-info';
import { usersEndpoints } from './users';

/** Every customer-instance endpoint, grouped by area. The server registers all of them. */
export const api = {
  meta: serverInfoEndpoints,
  setup: setupEndpoints,
  auth: authEndpoints,
  users: usersEndpoints,
  conversations: conversationsEndpoints,
  messages: messagesEndpoints,
  linkPreviews: linkPreviewsEndpoints,
  events: eventsEndpoints,
  files: filesEndpoints,
  invitations: invitationsEndpoints,
  admin: adminEndpoints,
  search: searchEndpoints,
  releases: releasesEndpoints,
  push: pushEndpoints,
} as const;

export type Api = typeof api;

export function allEndpoints(): AnyEndpoint[] {
  return Object.values(api).flatMap((group) => Object.values(group) as AnyEndpoint[]);
}
